import React from "react";
import { motion } from "framer-motion";
import { X, CheckCircle, DollarSign, User, Package } from "lucide-react";

const MarkAsPaidModal = ({ 
  isOpen, 
  onClose, 
  onConfirm, 
  request = null,
  isProcessing = false 
}) => {
  if (!isOpen || !request) return null;

  const handleConfirm = () => {
    onConfirm(request.id, "paid", "Marked as paid by admin");
  };

  return (
    <div className="flex fixed inset-0 z-50 justify-center items-center bg-black bg-opacity-50">
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        exit={{ opacity: 0, scale: 0.9 }}
        className="mx-4 w-full max-w-lg bg-white rounded-2xl shadow-xl"
      >
        {/* Header */}
        <div className="flex justify-between items-center p-6 border-b border-gray-200">
          <div className="flex gap-3 items-center">
            <div className="p-2 bg-green-100 rounded-lg">
              <CheckCircle className="w-5 h-5 text-green-600" />
            </div>
            <h2 className="text-xl font-bold text-gray-900">Mark as Paid</h2>
          </div>
          <button
            onClick={onClose}
            className="p-2 text-gray-400 rounded-lg transition-colors hover:text-gray-600 hover:bg-gray-100"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        {/* Content */}
        <div className="p-6">
          <div className="mb-6 text-center">
            <div className="flex justify-center items-center mx-auto mb-4 w-16 h-16 bg-green-100 rounded-full">
              <DollarSign className="w-8 h-8 text-green-600" />
            </div>
            <h3 className="mb-2 text-lg font-semibold text-gray-900">
              Confirm Payment
            </h3>
            <p className="text-gray-600">
              Are you sure you want to mark this payout request as paid?
            </p>
          </div>

          {/* Request Details */}
          <div className="p-4 mb-6 bg-gray-50 rounded-lg">
            <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
              <div className="flex gap-2 items-center">
                <User className="w-4 h-4 text-gray-500" />
                <span className="text-sm font-medium text-gray-900">{request.promoterName}</span>
              </div>
              <div className="flex gap-2 items-center">
                <Package className="w-4 h-4 text-gray-500" />
                <span className="text-sm font-medium text-gray-900">{request.productName}</span>
              </div>
              <div className="flex gap-2 items-center">
                <DollarSign className="w-4 h-4 text-gray-500" />
                <span className="text-sm font-medium text-gray-900">GH₵{request.amount.toLocaleString()}</span>
              </div>
              <div className="flex gap-2 items-center">
                <span className="text-sm text-gray-500">Commission:</span>
                <span className="text-sm font-medium text-gray-900">{request.commissionRate}%</span>
              </div>
            </div>
          </div>

          

          <div className="text-sm text-center text-gray-500">
            This action will mark the payout request as completed and notify the promoter.
          </div>
        </div>

        {/* Footer */}
        <div className="flex gap-3 p-6 border-t border-gray-200">
          <button
            onClick={onClose}
            disabled={isProcessing}
            className="flex-1 px-4 py-2 text-gray-700 bg-white rounded-lg border border-gray-300 transition-colors hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            Cancel
          </button>
          <button
            onClick={handleConfirm}
            disabled={isProcessing}
            className="flex flex-1 gap-2 justify-center items-center px-4 py-2 text-white bg-green-600 rounded-lg transition-colors hover:bg-green-700 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {isProcessing ? (
              <>
                <div className="w-4 h-4 rounded-full border-2 border-white animate-spin border-t-transparent"></div>
                Processing...
              </>
            ) : (
              <>
                <CheckCircle className="w-4 h-4" />
                Mark as Paid
              </>
            )}
          </button>
        </div>
      </motion.div>
    </div>
  );
};

export default MarkAsPaidModal;
